import React from "react";

import { withStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogTitle as MuiDialogTitle, DialogContent as MuiDialogContent, IconButton, Typography } from "@material-ui/core";
import { Close as CloseIcon, Settings as SettingsIcon } from "@material-ui/icons";

import Disposition from "../Disposition/Disposition";

const styles = (theme) => ({
	root: {
		margin: 0,
		padding: theme.spacing(2),
	},
	closeButton: {
		position: "absolute",
		insetInlineEnd: theme.spacing(1),
		top: theme.spacing(1),
		color: theme.palette.grey[500],
	},
});

const DialogTitle = withStyles(styles)((props) => {
	const { children, classes, onClose, ...other } = props;
	return (
		<MuiDialogTitle disableTypography className={classes.root} {...other}>
			<Typography variant="h6">{children}</Typography>
			{onClose ? (
				<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
					<CloseIcon />
				</IconButton>
			) : null}
		</MuiDialogTitle>
	);
});

const DialogContent = withStyles((theme) => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default function ConferenceDisposition(props) {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	return (
		<div style={{ marginInlinestart: "12px", marginInlineEnd: "10px" }}>
			<Button variant="outlined" size="small" title="Disposition" onClick={handleClickOpen} style={{ color: "#aaa", padding: "0px", minWidth: "auto" }}>
				<SettingsIcon />
			</Button>
			<Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} maxWidth="lg">
				<DialogTitle id="customized-dialog-title" onClose={handleClose} style={{ marginBottom: "15px" }}></DialogTitle>
				<DialogContent>
					<Disposition actionOriginate="conference" confLeadId={props.leadId} />
				</DialogContent>
			</Dialog>
		</div>
	);
}
